export default __webpack_public_path__ + "static/media/logo3.27850462.jpg";